<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">История</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Поиск по названию">
          <b-field>
            <b-autocomplete
              :data="async_data"
              :placeholder="search_placeholder"
              field="search"
              :loading="isFetching"
              @typing="getAsyncData"
              @select="option => autocompleate(option)">

              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">
                    {{ props.option.name }}
                    <br>
                    <small>
                      {{$t('map.search_description')}} : {{ props.option.description}}
                    </small>
                  </div>
                </div>
              </template>

            </b-autocomplete>
            <p class="control">
              <button class="button is-danger" @click="clearProduct()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order"
        >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="date" label="Дата" sortable>
            <!-- {{ props.row.date }} -->
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}
          </b-table-column>

          <!-- <b-table-column field="product_name" label="Product Name" sortable>
            {{ props.row.product.product_name }}
          </b-table-column> -->

          <b-table-column field="product" label="Product Name" sortable>
            {{ props.row.product }}
          </b-table-column>

          <b-table-column field="user_id" label="Пользователь" sortable>
            <b-tag type="is-dark" v-if="props.row.user">
              <a href="#" class="app-history-user" @click="showUser(props.row.user.id)">
                {{ props.row.user.email }}
              </a>
            </b-tag>
          </b-table-column>

          <b-table-column field="action" label="Действие" sortable>
            {{ props.row.action }}
          </b-table-column>
          
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="sad-tear"
                  size="is-large">
                </b-icon>
              </p>
              <p>Данных нет.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapSearch } from "@/api"
import { EventBus } from "@/utils"

export default {
  name: "HistoryTable",
  data() {
    const data = []
    const async_data = []
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    return {
      data: data,
      async_data: async_data,
      //autocompleate
      isFetching: false,
      search_placeholder: 'Поиск по названию ЭНК',
      def_search_placeholder: 'Поиск по названию ЭНК',
      //pagination backend
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        type_id: null,
        group_id: null,
        order: 'asc',
        limit: 25
      },
    }
  },
  computed: {
    // 
  },
  mounted: function() {
    let $this = this
    
    this.$store.dispatch('getHistories')
      .then(response => {
        let data = response.data;
        $this.total = data.total

        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
  },
  methods: {
    getAsyncData: debounce(function (search) {
      let $this = this
      if (!search.length) {
        this.async_data = []
        return
      }
      this.isFetching = true
      mapSearch(search)
      .then(response => {
        let data = response.data.data;
        if (data.length){
          this.async_data = []
          data.forEach((item) => this.async_data.push(item))
        }
        else{
          $this.async_data = []
        }
      })
      .catch(error => {
        $this.async_data = []
      })
      .finally($this.isFetching = false)

    }, 500),
    autocompleate: function(option){
      this.filters.product_id = option.id
      this.search_placeholder = option.name
      this.pageChange()
    },
    clearProduct(){
      this.filters.product_id = null
      this.search_placeholder = this.def_search_placeholder
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
     
      this.$store.dispatch('getPageHistories', {page: this.currentPage, filters: this.filters})
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    },
    showUser(item){
      EventBus.$emit("showModal", "user.edit", item)
    },
  }
}
</script>
<style scoped>
a.app-history-user {
  color: white;
}
</style>